import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ReportLock } from '../../../models/report-lock.model';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {
  @Input() lockedReports: ReportLock[];
  @Output() unlockReport = new EventEmitter<ReportLock>();

  constructor() {}

  ngOnInit() {}

  onUnlockReport(report: ReportLock) {
    console.log(report);
    this.unlockReport.emit(report);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/report-management/reports/reports.component.ts